/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgExternalAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11h-2V4H4v16h2.07c.159-1.111.591-2.203 1.362-3.092C8.453 15.728 9.99 15 12 15c1.565 0 2.854.441 3.838 1.213l-1.233 1.574C14.015 17.325 13.176 17 12 17c-1.49 0-2.453.521-3.057 1.217-.423.488-.706 1.105-.844 1.783H14v2H4a2 2 0 0 1-2-2V4zm8 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm7.586 13H16v2h3.586l-1.293 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L19.586 19z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgExternalAvatar as ExternalAvatar };
